// import { observable } from "mobx";
import React from "react";
import ReactDOM from "react-dom/client";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import AllRoutes from "./routes/AllRoutes";
import "./sass/styles.scss";
import ScrollToTop from "./routes/ScrollToTop";
import { history } from "./routes/history";
import packageJson from "../package.json";
import * as Sentry from "@sentry/react";
import NoDataFound from "./pages/NoDataFound/NoDataFound";
import { initSentry } from "./utils/functions";
import { HelmetProvider } from "react-helmet-async";

initSentry();
const root = ReactDOM.createRoot(document.getElementById("root"));
const baseNameWithoutSlash = packageJson?.homepage?.replaceAll("/", "");
const hrefArr = window.location.href?.split("/");

if (hrefArr?.length >= 4) {
  if (hrefArr?.[3] !== baseNameWithoutSlash) {
    history.push(`${packageJson?.homepage}/not-found`);
  }
}

root.render(
  <HelmetProvider>
    <Sentry.ErrorBoundary fallback={NoDataFound} showDialog>
      <HistoryRouter history={history} basename={packageJson?.homepage}>
        <ScrollToTop />
        <AllRoutes />
      </HistoryRouter>
    </Sentry.ErrorBoundary>
  </HelmetProvider>
);
